import { useQuery } from '@tanstack/vue-query'
import { getAccountStatus } from '../profileEndpoints'
import { profileKeys } from '../profileQueryKeys'

export function useAccountStatusQuery() {
  return useQuery({
    queryKey: profileKeys.accountStatus(),
    queryFn: getAccountStatus,
  })
}
